  <script>
  import { new_api } from "../auth_config.json";
  // import HowTo from '@/LearnMore/HowTo.vue';
  // import Blog from '@/Blogs/blogListing.vue';
  // import ClickOutside from 'vue-click-outside'

  // import SidebarComp from "@/Sidebar/Sidebar.vue";
  import ReportAssesment from "@/ReportAssesments/index.vue";

  export default {
    name: "nav-bar",
    components: {
      // HowTo, Blog
      // ClickOutside
      // SidebarComp,
      ReportAssesment,
    },
    
    props: {
      openSidebar:{
        type: Boolean,
        required: true,
      },
      stepForm: {
        type: Boolean,
        required: true,
      },
      activeTab: {
        type: Array,
      },
      showPeer: {
        type: Boolean,
        required: true,
      },
      showResult: {
        type: Boolean,
        required: true,
      },
      stepEnable: {
        type: Boolean,
        required: true,
      },
      dataLoading: {
        type: Boolean,
        required: true,
      },
      dark: {
        type: Boolean,
        required: true,
      },
      collapsedChecked:{
        type: Boolean,
        required: true,
      }
    },
    watch: {
      collapsedChecked: {
        handler(value) {
          this.collapsedCheckbox = value;
        },
        deep: true,
      },
      dataLoading: {
        handler(value) {
          this.reportLoading = value;
        },
        deep: true,
      },
      stepEnable: {
        handler(value) {
          if (this.activateTab != 3) {
            if (value) {
              this.activateTab = 1;
            } else {
              this.activateTab = 2;
            }
          }
        },
        deep: true,
      },
    },
    data() {
      let token;
      try {
        var cookieArr = document.cookie.split(";");

        // Loop through the array elements
        for (var i = 0; i < cookieArr.length; i++) {
          var cookiePair = cookieArr[i].split("=");

          /* Removing whitespace at the beginning of the cookie name
          and compare it with the given string */
          if ("userDetail" == cookiePair[0].trim()) {
            // Decode the cookie value and return
            token = decodeURIComponent(cookiePair[1]);
          }
        }
      } catch (e) {}

      return {
        old_password: "",
        new_password: "",
        access_token: token,
        peer: this.showPeer,
        isSticky: false,
        stickyClass: "is_sticky",
        scrollPosition: 0,
        checked: false,
        opened: false,
        modalShow: false,
        data: null,
        buttonOpen: false,
        reportClick: false,
        activateTab: 1,
        reportLoading: true,
        collapsedCheckbox:false,
        currentParam:'',
        msg: "Would you like to save the report before you leave? \nIf not, your session data could be lost.",
        steps: [
          {
            target: ".intro_step_1", // We're using document.querySelector() under the hood
            header: {
              title: "Get Started",
            },
            content: `Discover <strong>Vue Tour</strong>!`,
            params: {
              placement: "top",
            },
          },
        ],
      };
    },
    created() {
      try {
        this.checked =
          localStorage.getItem("mode") === null
            ? false
            : localStorage.getItem("mode") === "false"
            ? false
            : true;
      } catch (e) {
        this.checked = true;
      }

      window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    async mounted() {
      if (this.$route.query.report) {
        this.activateTab = 3;
        this.reportClick = true;
        this.$bvModal.show("modal-fullscreen");
        this.$router.replace({ query: null });
      }
      if (this.$route.query.onboard) {
        this.activateTab = 1;
      }
      if (this.$route.query.mainapp) {
        this.activateTab = 2;
        this.onByPass();
        this.$router.replace({ query: null });
      }
      if (this.$route.query.profile) {
        this.$parent.activeTab = ['Your Profile'];
        this.$router.replace({ query: null });
      }
      if (this.$route.query.income) {
        this.$parent.activeTab = ['Income'];
        this.$router.replace({ query: null });
      }
      if (this.$route.query.expense) {
        this.$parent.activeTab = ['Your Major Expenses'];
        this.$router.replace({ query: null });
      }
      if (this.$route.query.result) {
        this.$parent.activeTab = ['Your Result'];
        this.$router.replace({ query: null });
        
      }
      const storedData = await this.$cookies.get("storedData");
      if (storedData) {
        if (storedData.age && this.activateTab === 1) {
          this.activateTab = 2;
        }
      }

      window.addEventListener("loginEvent", (event) => {
        this.data = event.detail;
      });

      window.addEventListener("paramClick", event => {
        this.openPopUp(event.detail);
      });
      const hash = new URL(window.location.href).hash;
      if (hash && hash.includes("#access_token=")) {
        const token = hash.split("#access_token=")[1];
        try {
          localStorage.setItem("access_token", token);
        } catch (e) {}
        this.access_token = token;
        this.$parent.access_token = token;
        history.replaceState({}, document.title, ".");
      }
      // var hash = window.location.href;
      // console.log(hash,'sasaaa')
      // prevent click outside event with popupItem.
      this.popupItem = this.$el;
    },
    // do not forget this section
    directives: {
      // ClickOutside
    },
    computed: {
      userName() {
        return (
          (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
            ? this.$cookies.get("userDetail").data.name
            : null) || this.data
        );
      },
      userId() {
        return (
          (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
            ? this.$cookies.get("userDetail").data.id
            : null) || this.data
        );
      },
      getUserId() {
        return (
          (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
            ? this.$cookies.get("userDetail").data.id
            : null) || this.data
        );
      },
      userType() {
        return (
          (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
            ? this.$cookies.get("userDetail").data.user_type
            : null) || this.data
        );
      },
      userEmail() {
        return (
          (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
            ? this.$cookies.get("userDetail").data.email
            : null) || this.data
        );
      },
      getCookies() {
        return (
          (this.$cookies.get("userDetail") &&
            this.$cookies.get("userDetail").data) ||
          this.$cookies.get("userDetail")
        );
      },
    },
    methods: {
      changeCheckbox(target){
        this.$parent.collapsedChecked = target
      },
      openPopUp(param) {
        this.currentParam = param
        var reportNotSaved = window.localStorage.getItem("saveReport");
        if (reportNotSaved === "no" && !this.stepEnable && this.showResult) {
          this.$bvModal.show("save-report");
        } else {
          if(param=='account'){
              window.location.replace("https://biz.spendid.io/user/account");
          }
          if(param=='faq'){
              window.location.replace("https://spendid.io/faqs");
          }
          if(param=='contact_us'){
              window.location.replace("https://mybudgetreport.com/contact");
          }
          if(param=='user'){
              window.location.replace("https://biz.spendid.io/user/list");
          }
          if(param=='users'){
              window.location.replace("https://biz.spendid.io/user/list");
          }
          if(param=='analytics'){
              window.location.replace("https://biz.spendid.io/analytics");
          }
          if(param=='user_reports'){
              window.location.replace("https://biz.spendid.io/user/child-user-reports");
          }
        }
      },
      menuClick(param, open) {
        // switch (param) {
        //   case "account":
            if (open) {
              this.$parent.saveReport();
            }
            setTimeout(() => {
              if(this.currentParam=='account'){
                window.location.replace("https://biz.spendid.io/user/account");
              }
              if(this.currentParam=='faq'){
                  window.location.replace("https://spendid.io/faqs");
              }
              if(this.currentParam=='contact_us'){
                  window.location.replace("https://mybudgetreport.com/contact");
              }
              if(this.currentParam=='user'){
                  window.location.replace("https://biz.spendid.io/user/list");
              }
              if(this.currentParam=='users'){
                  window.location.replace("https://biz.spendid.io/user/list");
              }
              if(this.currentParam=='analytics'){
                  window.location.replace("https://biz.spendid.io/analytics");
              }
              if(this.currentParam=='user_reports'){
                  window.location.replace("https://biz.spendid.io/user/child-user-reports");
              }
            }, 2000);
        //     break;
        //   default:
        //     break;
        // }
      },
      autoFill(data) {
        this.$emit("fillAutoData", data);
        this.openSpendidApp(false);
        this.$emit("stepEnable", false);
      },
      onCheckBoxChange() {
        this.$parent.changeMode(this.checked);
      },
      openSpendidApp(arg = true) {
        this.outSideClickClose();
        this.$parent.stepEnable = false;
        this.$emit("stepEnable", false);

        let headers = {
          Authorization: "Bearer " + this.getCookies.access_token,
        };
        if (arg) {
          this.$http
            .get(`${new_api}/get-last-data-By-user`, { headers })
            .then((response) => {
              this.$emit("fillAutoData", response);
              // location.reload()
            });
        }
        // this.onByPass();
        if (this.activateTab !== 2) {
          this.activateTab = 2;
        }
      },
      reportPerticularClick() {
        // this.reportClick = true;
        this.$router.push({ path: "/", query: { report: "true" } });
        location.reload();
        // setTimeout(() => {
        //   this.$bvModal.show("modal-fullscreen");
        // }, 10);
      },
      outSideClickClose() {
        if (this.reportClick) {
          this.$bvModal.hide("modal-fullscreen");
        }
      },
      onByPass() {
        let headers = {
          Authorization: "Bearer " + this.getCookies.access_token,
        };
        this.$http
          .post(
            `${new_api}/report-save`,
            {
              name: "new Report",
            },
            { headers }
          )
          .then(
            (res) => {
              this.$cookies.set("assessmentId", res.data.reportId);

              this.$http
                .get(`${new_api}/get-last-data-By-user`, { headers })
                .then((response) => {
                  this.$emit("fillAutoData", response);
                  // location.reload()
                });

              // this.$emit('stepEnable', false)
            },
            (response) => {
              if (response.status == 401) {
                this.$cookies.remove("userDetail");
                this.$cookies.remove("storedData");
              }
            }
          );
      },
      changeNow() {
        const user = this.getCookies;
        let headers = {
          Authorization: "Bearer " + this.getCookies.access_token,
        };
        this.$http
          .post(
            `${new_api}/change-password`,
            {
              old_password: this.old_password,
              new_password: this.new_password,
              userId: user.id,
            },
            { headers }
          )
          .then(() => {
            this.old_password = "";
            this.new_password = "";
            this.$bvModal.hide("change-popup");
          })
          .catch((err) => {
            alert(err.response.data.message);
          });
      },
      btnClick() {
        window.open("https://biz.spendid.io/free-demo");
      },
      logoutAll() {
        let headers = {
          Authorization: "Bearer " + this.getCookies.access_token,
        };
        this.$http
          // .get(`https://biz.spendid.io/api/user-logout`, { headers })
          .get(`https://biz.spendid.io/user/account`, { headers })
          
          .then(() => {
            this.$cookies.remove("userDetail");
            localStorage.removeItem("access_token");
            this.$cookies.remove("storedData");
            this.$cookies.remove("dontshow");
            this.$cookies.remove("assessmentId");
            setTimeout(() => {
              window.location.href =
                "https://biz.spendid.io/logout-user-from-app";
                // "https://biz.spendid.io/logout-user-from-app";
            }, 1000);
            // location.reload()
          });
      },
      isMobile() {
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          return true;
        } else {
          return false;
        }
      },
      cancel() {
        this.$refs["startover"].hide();
      },
      toggle() {
        this.opened = !this.opened;
      },
      hide() {
        this.opened = false;
      },
      activeTabs(arg) {
        this.$parent[arg] = false;
        this.$parent.validateCheck();
        this.$parent.checkResultToggle();
      },
      handleScroll() {
        this.scrollPosition = window.scrollY;
        if (this.scrollPosition >= 200) {
          this.isSticky = true;
        } else {
          this.isSticky = false;
        }
      },
      login() {
        this.$auth.loginWithPop();
      },
      // Log the user out
      logout() {
        localStorage.removeItem("access_token");
        location.reload();
        //   this.$auth.logout({
        //     returnTo: window.location.origin
        // });
      },
    },
  };
  </script>

  <template>
    <div class="sticky-header-bar">
      <v-tour name="myTour" :steps="steps"></v-tour>
      <b-navbar toggleable="lg" class="header-nav zIndex1" id="navbar">
        <div class="d-flex align-items-center mr-2 mr-md-0">
          <!-- <button @click="$parent.openSidebar = openSidebar ? false : true" type="button" class="toggle-mobile mr-3 mr-md-2" ><i class="fa fa-bars"></i></button> -->
          <!-- <b-navbar-toggle size="sm" target="nav-collapse" class="mr-2 mr-lg-0">
            <span> </span>
            <span> </span>
            <span> </span>
          </b-navbar-toggle> -->
          <b-navbar-brand href="#" class="py-0">
            <img alt="logo" class="img-fluid" :src="['gradbudget-plan','gradbudget-school-plan'].includes(userType)?'imgs/logo-mini.png': 'imgs/logo-mini.png'" />
            <!-- <img alt="logo" class="img-fluid logo-d" :src="['gradbudget-plan','gradbudget-school-plan'].includes(userType)?'imgs/logo-d.png': 'imgs/logo-d.png'" />
            <img alt="logo" class="img-fluid logo-w" :src="['gradbudget-plan','gradbudget-school-plan'].includes(userType)?'imgs/logo-w.png': 'imgs/logo-w.png'"  /> -->
          </b-navbar-brand>
          <!-- <b-navbar-brand
            href="#"
            class="navbar-brand-mini py-0 d-inline-block d-sm-none"
          >
            <img alt="logo" class="img-fluid" src="imgs/logo-mini.png" />
          </b-navbar-brand> -->
        </div>
        <!-- <h4 class="predictive-budget-simulation font-urbanerounded-bold mb-0">Predictive Budget Simulation</h4> -->
        <!-- Right aligned nav items -->
        <b-navbar-nav class="b-navbar-right-side ml-md-auto align-items-center">
          <div class="navbar-right-side d-flex align-items-center">
            <label class="nav-theme-mode ml-2 mr-2 mb-0" onClick="bodyClassAdd()">
              <input
                type="checkbox"
                class="checkbox-switch darkLightChange"
                @change="onCheckBoxChange"
                v-model="checked"
              />
              <span class="checkbox-switch-label mb-0">
                <i class="fas fa-sun"></i>
                <i class="fas fa-moon"></i>
                <span class="ball"></span>
              </span>
            </label>

            <!-- <div class="acount-profile-wrap ml-2">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none p-0"
                no-caret
                right
              >
                <template #button-content>
                  <div
                    class="d-flex align-items-center"
                    href="https://biz.spendid.io/analytics"
                  >
                    <p class="profile_name truncate mb-0 mr-2">{{ userName }}</p>
                    <div class="profile_icon flex-shrink-0">
                      <img
                        class="img-fluid"
                        :src="`https://biz.spendid.io/api/get-image/${userId}?ver=${Math.random()}`"
                      />
                    </div>
                  </div>
                </template>
                <b-dropdown-item >
                  <span class="d-inline-block">{{ userName }}</span>
                </b-dropdown-item>
                <b-dropdown-item href="#" @click="openPopUp('account')">
                  <i class="fas fa-user mr-2" aria-hidden="true"></i>
                  <span class="d-inline-block">My Account</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="#" @click="logoutAll()">
                  <i class="fas fa-sign-out-alt mr-2" aria-hidden="true"></i>
                  <span class="d-inline-block">Logout</span>
                </b-dropdown-item>
              </b-dropdown> 
            </div> -->
          </div> 
         
          <div class="nav-action">
            <!-- <b-button
              class="btn-purple d-none mr-1 mr-lg-2"
              type="button"
              size="sm"
            >
              My Account
            </b-button> -->

            <b-button
              class="btn-green start-over d-none mr-1 mr-lg-2"
              type="button"
              @click="
                $parent.startOver();
                $parent.activeTab = ['Your Profile'];
              "
              size="sm"
            >
              Start Over
            </b-button>
            <!-- <b-button
              class="btn-green start-over d-none mr-1 mr-lg-2"
              type="button"
              size="sm"
              title="How To"
              @click="$parent.activeTab = ['How To']"
              v-scroll-to="{ el: '#navbar', offset: -170 }"
            >
              How To
            </b-button> -->

            <b-button
              v-if="stepForm"
              class="btn-green mr-1 mr-lg-2"
              type="button"
              @click="
                $parent.resetDefault(true);
                $parent.activeTab = ['Your Profile'];
              "
              >Start Over</b-button
            >
            <b-button
              @click="$parent.introStart()"
              class="btn-purple btn-md btn-radius btn-77 mr-1 mr-lg-2"
              type="button"
            >
            TUTORIAL
            </b-button>
            
            <!-- <b-button
              v-if="!stepForm"
              class="btn-green mr-1 mr-lg-2"
              title="Save Report"
              :disabled="reportLoading"
              @click="$parent.saveReport()"
              :class="{ disabled: reportLoading }"
            >
              Save Report
            </b-button> -->
            <b-button
              v-if="!stepForm"
              class="btn-danger mr-1 mr-lg-2 clear_input_btn"
              type="button"
              v-b-modal.startover
            >
              Clear Inputs
            </b-button>
            <!-- <b-button
              v-if="!stepForm"
              class="btn-green mr-1 mr-lg-2"
              type="button"
              title="How To"
              @click="$parent.activeTab = ['How To']"
              v-scroll-to="{ el: '#navbar', offset: -170 }"
            >
              How To
            </b-button> -->
            
            <!-- <b-button
              v-if="!stepForm"
              href="https://spendid.io/calculators"
              class="btn-green mr-1 mr-lg-2"
              type="button"
              size="sm"
              target="_blank"
            >
              Calculators
            </b-button> -->
          </div>
        </b-navbar-nav>
      </b-navbar>

      <div class="nav-collapse-updated">
        <div class="collapsed-checked text-center">
          <b-form-checkbox  @change="changeCheckbox" name="check-button" switch>
            <span>Expand All </span>
          </b-form-checkbox>
        </div>
        <div class="clear-start-over">
          <b-button class="btn-danger" @click="$parent.resetDefault(true);$parent.startOver();$parent.activeTab = ['Your Profile'];">Clear & Start Over</b-button>
        </div>
        <div class="nav-data">
          <b-nav-item
            :class="{ active: activeTab.includes('Your Profile') }"
            @click="$parent.activeTab = activeTab.includes('Your Profile')?[]:['Your Profile'];$parent.scrollToSection('Your Profile')"
          >
            <span class="n-icon">
              <i class="fas fa-user"></i>
            </span>
            <span class="n-text">Profile</span>
          </b-nav-item>
          <b-nav-item
            :class="{ active: activeTab.includes('Income')}"
            @click="$parent.activeTab = activeTab.includes('Income')?[]:['Income'];$parent.scrollToSection('Income')"
          >
            <span class="n-icon">
              <i class="fas fa-user"></i>
            </span>
            <span class="n-text">Income</span>
          </b-nav-item>
          <b-nav-item
            id="nav-item-expense"
            :class="{
              active:
                activeTab.includes('Your Major Expenses') ||
                activeTab.includes('Common Monthly Bills') ||
                activeTab.includes('Other Discretionary Expenses'),
            }"
            @click="$parent.activeTab = activeTab.includes('Your Major Expenses')?[]:['Your Major Expenses'];$parent.scrollToSection('Your Major Expenses')"
          >
            <span class="n-icon">
              <i class="fas fa-funnel-dollar"></i>
            </span>
            <span class="n-text">Expenses</span>
          </b-nav-item>
          <b-nav-item
            :class="{ active: activeTab.includes('Your Result') }"
            @click="$parent.activeTab = activeTab.includes('Your Result')?[]:['Your Result'];$parent.scrollToSection('Your Result')"
          >
            <span class="n-icon">
              <i class="fas fa-poll"></i>
            </span>
            <span class="n-text">Results</span>
          </b-nav-item>
        </div>
      </div>

      <div v-if="showResult" class="results-btn-mobile d-none d-lg-none">
        <b-button
          title="Results"
          @click="activeTabs('visibleCashHealthAnalysis')"
          v-scroll-to="{ el: '#cash-flow-score', offset: -100 }"
          variant="success"
          class="btn-green btn-sm"
        >
          See Results
        </b-button>
      </div>

      <b-modal
        id="startover"
        modal-class="clear-inputs-modal"
        size="small"
        ref="startover"
        hide-footer
        hide-header
        title="Reset All Field Data"
      >
        <div class="mb-4 d-block text-center">
          <i class="fas fa-exclamation-circle text-warning fa-5x"></i>
        </div>
        <div class="my-4 d-block text-center">
          <h3 class="font-weight-bold">Are you sure?</h3>
          <p>You want to <b>Reset</b> all input data fields</p>
        </div>
        <div class="my-4 d-block text-center">
          <b-button variant="danger" @click="cancel()" class="mx-1">
            Cancel
          </b-button>
          <b-button
            type="button"
            @click="$parent.resetDefault(false)"
            variant="success"
            class="btn-green mx-1"
            >Reset All</b-button
          >
        </div>
      </b-modal>
      <!-- custom_blocks end-->
      <b-modal
        id="save-report"
        modal-class="saved-reports-modal"
        hide-header
        hide-footer
      >
        <b-container fluid>
          <b-row>
            <b-col class="text-center">
              <div class="mb-4 d-block">
                <i class="fas fa-exclamation-circle text-warning fa-5x"></i>
              </div>
              {{ msg }}
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center mt-3">
              <b-button
                size="sm"
                @click="menuClick('account', true)"
                class="btn-green m-1"
                >Save Changes</b-button
              >
              <b-button
                size="sm"
                @click="menuClick('account', false)"
                class="btn-orange m-1"
                >Discard Changes</b-button
              >
              <b-button
                size="sm"
                @click="$bvModal.hide('save-report')"
                class="btn-danger m-1"
                >Cancel</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
      <!-- ReportAssesment Modal-->
      <b-modal
        id="modal-fullscreen"
        modal-class="saved-reports-modal"
        size="xl"
        hide-header
        hide-footer
      >
        <ReportAssesment v-on:autoFill="autoFill" />
      </b-modal>
    </div>
  </template>

  <style scoped>

.nav-divider {
    background-color: #444;
    width: 2px;
    margin: 0 8px;
    height: 32px;
  }
  .darkmode .nav-divider {
    background-color: #fff;
  }
  .predictive-budget-simulation {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    margin: 0 auto;
    font-size: 18px;
    text-align: center;
    /* position: absolute;
    left: 0;
    right: 0; */
}
.predictive-budget-simulation {
  color: #000;
}
.darkmode .predictive-budget-simulation {
  color: #fff;
}

@media screen and (min-width: 1620px) {
  .predictive-budget-simulation {  
    position: absolute;
    left: 0;
    right: 0;
    width: 230px;
    font-size: 22px;
  }
}
@media screen and (max-width: 1366px) {
  .predictive-budget-simulation{
    display: none;
  }
}
/* @media screen and (max-width:991px) {
  .predictive-budget-simulation{
    display: none;
  }
} */

  @media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
    .navbar-logo a img,
    .navbar-logo img,
    .navbar-logo-customer img,
    .navbar-logo-customer a img {
      max-height: 54px;
    }
  }

  @media screen and (max-width: 375px) {
    .navbar-logo a img,
    .navbar-logo img,
    .navbar-logo-customer img,
    .navbar-logo-customer a img {
      max-height: 48px;
    }
  }

  /* New CSS Start form here */
  /*.header-nav {
    box-shadow: rgba(12, 18, 18, 0.1) 0px 4px 10px;
    transition: 0.6s;
    -webkit-transition: 0.6s;
    -moz-transition: 0.6s;
    -o-transition: 0.6s;
    transition: 0.6s;
  }*/
  .header-nav .navbar-brand img {
    max-height: 80px
  }

.darkmode .header-nav .navbar-brand .logo-w,.header-nav .navbar-brand .logo-d {
    display: inline-block
}

.darkmode .header-nav .navbar-brand .logo-d,.header-nav .navbar-brand .logo-w {
    display: none
}
.header-nav.isSticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 148px;
}
@media (max-width: 540px) {
  .truncate {
    max-width: 116px;
  }
}
@media screen and (min-width: 991px) and (max-width: 1580px) {
  .header-nav .navbar-brand img {
    max-height: 80px;
  }
  .darkmode .header-nav .navbar-brand .logo-w,
  .header-nav .navbar-brand .logo-d {
    display: inline-block;
  }
}
@media screen and (min-width: 1830px) and (max-width: 3500px) {
  .header-nav .navbar-collapse {
    /* position: absolute;
    left: 0;
    right: 0; */
    justify-content: center;
  }
}
@media (min-width: 1441px) {
  .header-nav .navbar-collapse {
    margin-left: 48px;
  }
}
@media (min-width: 1440px) {
  .header-nav .navbar-collapse {
    /* justify-content: center; */
    margin-left: 40px;
  }
}
@media only screen and (max-width: 1024px) {
  .b-navbar-right-side::before {
    height: 96px !important;
  }
}

/* @media (max-width: 540px) {
  .step_form_area .header-nav .navbar-brand img {
    display: none;
  }

  .header-nav.isSticky {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }

  /* .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 148px;
  } */

  @media screen and (min-width: 991px) and (max-width: 1580px) {
    .header-nav .navbar-brand img {
      max-height: 48px;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1346px) {
    .header-nav .navbar-brand img {
      max-height: 44px;
    }
  }
  @media screen and (min-width: 1830px) and (max-width: 3500px) {
    .header-nav .navbar-collapse {
      position: absolute;
      left: 0;
      right: 0;
      justify-content: center;
    }
  }
  @media (min-width: 1441px) {
    .header-nav .navbar-collapse {
      margin-left: 48px;
    }
  }
  @media (min-width: 1440px) {
    .header-nav .navbar-collapse {
      /* justify-content: center; */
      margin-left: 40px;
    }
  }
  @media only screen and (max-width: 1024px) {
    .b-navbar-right-side::before {
      height: 96px !important;
    }
  }
  @media (max-width: 767px) {
    .header-nav .navbar-brand img {
      max-height: 36px;
    }
  }
  /* @media (max-width: 540px) {
    .step_form_area .header-nav .navbar-brand img {
      display: none;
    }
  } */
  .step_form_area .header-nav .start-over,
  .step_form_area .header-nav .btn-purple {
    display: inline-block !important;
    flex-shrink: 0;
  }

  .header-nav .navbar-brand {
    min-height: auto;
  }
  .navbar-toggler {
    padding: 0.25rem 0.45rem;
    font-size: 1rem;
  }
  .navbar-toggler .navbar-toggler-icon {
    display: none;
  }
  .darkmode .navbar-toggler {
    background-color: #2ba195;
    border: 1px solid #2ba195 !important;
  }
  .darkmode .navbar-toggler {
    color: #fff !important;
  }

  .darkmode .navbar.header-nav {
    background: #151d32 !important;
    /* border-bottom: solid 1px #43495a; */
  }
  .darkmode .header-nav.isSticky {
    background-color: #1e2041 !important;
    /* border-bottom: solid 1px #43495a; */
    top: 0px;
    /* transform: translateY(24px);
    transition: transform .4s; */
  }

  @keyframes bounce {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}

.btn-purple.jumping {
  animation: bounce 1s infinite;
}
  @media (min-width: 1280px) {
    .navbar-right-side {
      -ms-flex-order: 2;
      -webkit-box-ordinal-group: 3;
      order: 2;
    }
    .nav-action {
      -ms-flex-order: 1;
      -webkit-box-ordinal-group: 2;
      order: 1;
    }
    .navbar-nav.b-navbar-right-side {
      flex-direction: row;
    }
  }

  @media (max-width: 1279px) {
    .navbar-right-side {
      margin-bottom: 10px;
      padding-bottom: 6px;
      border-bottom: solid 1px #eee;
    }
    
    .darkmode .navbar-right-side {
      border-bottom: solid 1px #43495a;
    }
    .step_form_area .header-nav .navbar-right-side {
      margin-bottom: 0px;
      padding-bottom: 0px;
      border-bottom: solid 1px transparent;
    }
  }

  @media screen and (min-width: 895px) and (max-width: 1190px) {
    .header-nav .btn-green,
    .header-nav .btn-danger,
    .header-nav .btn-info,
    .header-nav .btn-purple {
      /* padding: 0.3rem 0.5rem !important; */
      font-size: 0.7rem !important;
    }
  }
  /* @media screen and (min-width: 992px) and (max-width: 1110px) {
    .navbar-brand {
      display: none !important;
    }
    .navbar-brand.navbar-brand-mini {
      display: inline-block !important;
    }
  } */
  /* .step_form_area .header-nav .navbar-right-side {
    top: -15px;
    right: -5px;
  } */
  @media (max-width: 767px) {
    .navbar-right-side,
    .darkmode .navbar-right-side {
      border-bottom: none;
    }
    /* .step_form_area .header-nav .navbar-right-side,
    .navbar-right-side {
      right: 0;
    } */
    .navbar-right-side {
      position: absolute;
      top: -34px;
      z-index: 9999;
      justify-content: flex-end !important;
      width: 80%;
      border: solid;
      right: 0;
      justify-content: flex-end;
      border: none;
    }

    .nav-action {
      margin-top: 8px;
      margin-left: -15px;
      margin-right: -15px;
      border-top: solid 1px #e3e3e3;
      text-align: center;
      padding-top: 7px;
    }
    .step_form_area .header-nav .b-navbar-right-side .nav-action {
      width: 100%;
    }
    .darkmode .nav-action {
      border-top: solid 1px #43495a;
    }
  }
  /* .darkmode .navbar-right-side {
    border-bottom: solid 1px #43495a;
  } */
  .navbar-nav.b-navbar-right-side {
    display: flex;
    position: relative;
  }
  @media (max-width: 767px) {
    .b-navbar-right-side {
      width: 100%;
    }
    /* .step_form_area .header-nav .b-navbar-right-side {
      width: auto;
    } */
    .b-navbar-right-side:before {
      display: none;
    }
  }
  @media (max-width: 1279px) {
    .navbar-nav.b-navbar-right-side {
      display: block;
    }
    .step_form_area .navbar-nav.b-navbar-right-side,
    .step_form_area .header-nav .nav-action {
      display: flex;
    }
    .step_form_area .navbar-nav.b-navbar-right-side {
      flex-direction: row-reverse;
    }
    .b-navbar-right-side::before {
      content: "";
      position: absolute;
      left: 0;
      top: -11px;
      background-color: #eee;
      width: 1px;
      height: 96px;
    }
    .step_form_area .header-nav .b-navbar-right-side::before {
      display: none;
    }
    .darkmode .b-navbar-right-side::before {
      background-color: #43495a;
    }
    .navbar-right-side,
    .nav-action {
      padding-left: 20px;
    }
  }

  @media (max-width: 767px) {
    .navbar-right-side,
    .nav-action {
      padding-left: 0px;
      justify-content: center;
    }
  }
  .step_form_area .header-nav .navbar-right-side,
  .step_form_area .header-nav .nav-action {
    padding-left: 0px;
  }

  .nav-action .btn,
  .nav-action .btn-green,
  .nav-action .btn-danger,
  .nav-action .btn-purple {
    padding: 0.28rem 0.65rem;
    font-size: 0.8rem;
  }
  .nav-action .btn-purple.btn-md{
    padding: 0.6rem 1.3rem;
    font-size: 1rem;
    line-height: 1;
  }
  .nav-action .btn-purple:hover{
    background-color: #864ae6!important;
    border-color: #864ae6!important;
  }
  .btn-radius{
    border-radius: 100px!important;
  }
  @media (max-width: 1337px) {
    .nav-action .btn,
    .nav-action .btn-green,
    .nav-action .btn-danger,
    .nav-action .btn-purple {
      font-size: 0.7rem;
    }
  }
  @media (max-width: 1382px) {
    .header-nav .nav-item .nav-link {
      margin-right: 12px;
    }
  }
  @media (max-width: 1002px) {
    .header-nav .nav-item .nav-link {
      margin-right: 10px;
    }
  }
  /* @media (min-width: 767px) {
    .darkmode .step_form_area .navbar.header-nav,
    .step_form_area .header-nav,
    .darkmode .step_form_area .header-nav.isSticky {
      background-color: transparent !important;
      box-shadow: none;
      border: none;
    }
  } */
  /* .step_form_area .navbar.header-nav .navbar-toggler {
    display: none;
  } */
  .step_form_area > div {
    width: 100%;
  }
  /* 
  .header-nav.isSticky,
  .step_form_area .header-nav {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
    width: 100%;
    width: calc(100% - 320px);
    -webkit-transition: all 0.4s ease;
    transition: all 0.4s ease;

    -webkit-animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
    animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  } */
  @media (max-width: 991px) {
    /* navbar always show on mobile start css */
    .navbar-collapse.collapse {
      display: block !important;
      height: auto !important;
      padding-bottom: 0;
      overflow: visible !important;
    }
    /* navbar always show on mobile end css*/
    /* .step_form_area .header-nav #nav-collapse {
      top: 60px;
    } */
    #nav-collapse {
      position: fixed;
      left: 0;
      right: 0;
      background: #fff;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      /* top: 56px; */
      z-index: 1031;
      padding: 4px 17px;
      top: 93px;
      /* height: 90px; */
    }
    .step_form_area .header-nav #nav-collapse {
      top: 60px;
    }
    /* .navbar-collapse.collapse.show {
      display: block;
    } */
    .navbar-nav {
      flex-direction: row;
      justify-content: center;
    }
    .header-nav .nav-item .nav-link {
      margin: 0 30px;
      font-size: 16px;
    }
    .header-nav .nav-item:last-child .nav-link,
    .header-nav .nav-item:first-child .nav-link {
      margin: 0;
    }
    .darkmode #nav-collapse {
      background-color: #151d32 !important;
      border-top: 1px solid #43495a;
      border-bottom: 1px solid #43495a;
    }

    .navbar-toggler span {
      display: block;
      background-color: #444;
      height: 2px;
      width: 20px;
      margin-top: 4px;
      margin-bottom: 4px;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      position: relative;
      left: 0;
      opacity: 1;
    }
    .darkmode .navbar-toggler span {
      background-color: #fff;
    }
    .navbar-toggler span:nth-child(1),
    .navbar-toggler span:nth-child(3) {
      -webkit-transition: transform 0.35s ease-in-out;
      -moz-transition: transform 0.35s ease-in-out;
      -o-transition: transform 0.35s ease-in-out;
      transition: transform 0.35s ease-in-out;
    }
    .navbar-toggler:not(.collapsed) span:nth-child(1) {
      position: absolute;
      left: 23px;
      top: 44px;
      -webkit-transform: rotate(135deg);
      -moz-transform: rotate(135deg);
      -o-transform: rotate(135deg);
      transform: rotate(135deg);
      opacity: 0.9;
    }

    .navbar-toggler:not(.collapsed) span:nth-child(2) {
      height: 12px;
      visibility: hidden;
      background-color: transparent;
    }

    .navbar-toggler:not(.collapsed) span:nth-child(3) {
      position: absolute;
      left: 23px;
      top: 44px;
      -webkit-transform: rotate(-135deg);
      -moz-transform: rotate(-135deg);
      -o-transform: rotate(-135deg);
      transform: rotate(-135deg);
      opacity: 0.9;
    }
  }
  @media (max-width: 767px) {
    /* .step_form_area .header-nav #nav-collapse {
      top: 52px;
    } */
    .step_form_area .header-nav #nav-collapse {
      top: 94px;
    }
    .navbar-toggler span {
      height: 2px;
      width: 20px;
    }
    .navbar-toggler:not(.collapsed) span:nth-child(1),
    .navbar-toggler:not(.collapsed) span:nth-child(3) {
      top: 20px;
    }
  }
  @media (max-width: 370px) {
    .header-nav .nav-item .nav-link {
      margin: 0 20px;
    }
  }
  /* @media (max-width: 767px) {
    .navbar-collapse,
    .navbar-collapse.collapse {
      background-color: rgba(0, 0, 0, 0.8);
      position: fixed;
      right: inherit;
      left: 0;
      bottom: 0;
      top: 68px;
      padding-top: 50px;
      padding-left: 30px;
      padding-right: 15px;
      padding-bottom: 15px;
      width: 20em;
      height: 100vh;
      box-shadow: 5px 0 0 #000;
    }

    .navbar-collapse.collapsing.show {
      -webkit-transition: left 0.3s ease;
      -o-transition: left 0.3s ease;
      -moz-transition: left 0.3s ease;
      transition: left 0.3s ease;
      left: -20.3em;
      bottom: 0;
      top: 68px;
      right: inherit;
    }

    .navbar-collapse.show {
      left: 0;
      bottom: 0;
      top: 68px;
      right: inherit;
      -webkit-transition: left 0.3s ease-in;
      -o-transition: left 0.3s ease-in;
      -moz-transition: left 0.3s ease-in;
      transition: left 0.3s ease-in;
    }
  } */

  .nav-collapse-updated {
      box-shadow: rgba(12, 18, 18, 0.1) 0px 4px 10px;
      background: #fff;
      margin-top: 0;
      position: relative;
      z-index: 9;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      -webkit-justify-content: center;
      align-items: center;
      -webkit-align-items: center;
      height: 74px;
      border-top: 2px solid #E3E3E3;
  }
  @media (min-width: 1580px) {
    .nav-collapse-updated {
      height: 70px;
    }
  }
  .darkmode .nav-collapse-updated{
    background: #151d32;
    border-color: #525B75;
    border-bottom: solid 1px #525B75;
  }

  .nav-collapse-updated .nav-data {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
  }
  @media (max-width: 767px) {
    .nav-collapse-updated .nav-data{
      margin-top: 10px;
    }
  }
  .nav-collapse-updated .nav-data .nav-item {
    list-style-type: none;
  }
  .nav-collapse-updated .nav-data .nav-item a {
    color: #313030;
    font-weight: 600;
    font-size: 18px;
    background: #f8f8ff !important;
    margin: 0 10px;
    border: 4px solid #DEE2E6;
    border-radius: 4px;
    padding:4px 10px;  
    width: 114px;
    text-align: center;
    display: block;
    position: relative;
  }
  .darkmode .nav-collapse-updated .nav-data .nav-item a {
    color: #fff;
  }

  .darkmode .nav-collapse-updated .nav-data .nav-item a {
    background: #32384E !important;
    border: 1px solid #525B75;
  }
  .nav-collapse-updated .nav-data .nav-item.active a {
    background: #2BA195 !important;
    color: #fff;
    border-color: #6e2c98;
  }
  .nav-collapse-updated .nav-data .nav-item a .n-icon {
    display: none;
  }
  /* .nav-collapse-updated .nav-data .nav-item a::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    border-bottom: 1px solid #DEE2E6;
    right: -6px;
    top: -6px;
    background: #fff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .nav-collapse-updated .nav-data .nav-item a::before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    border-top: 1px solid #DEE2E6;
    left: -6px;
    bottom: -6px;
    background: #fff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
   */
  .darkmode .nav-collapse-updated .nav-data .nav-item a::after {
    border-bottom: 1px solid #525B75;
  }
  .darkmode .nav-collapse-updated .nav-data .nav-item a::before {
    border-top: 1px solid #525B75;
  }
  @media (max-width: 767px) {
    .nav-collapse-updated .nav-data .nav-item a::before,
    .nav-collapse-updated .nav-data .nav-item a::after{
      display: none;
    }
  }
  .darkmode .nav-collapse-updated .nav-data .nav-item a::after,
  .darkmode .nav-collapse-updated .nav-data .nav-item a::before{
    background: #151d32;
  }
  .toggle-mobile {
    font-size: 22px;
    display: none;
  }
  .toggle-mobile{
    padding:0;
    background-color: transparent;
    border-color:transparent;
  }
  </style>
